module.exports = __webpack_public_path__ + "img/PT5140.a7fceb78.png";